export default __webpack_public_path__ + "static/example-purple-pepper-c4f6b521d74d3697c8939c40e6530344.svg";